import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GraphyEnrollmentListComponent } from './graphy-enrollment-list/graphy-enrollment-list.component';
import { GraphyLearnerListComponent } from './graphy-learner-list/graphy-learner-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      // {
        // path: '',
        //   component: GraphyEnrollmentListComponent,
        //   data: { title: 'Graphy Enrollments' }
        // },
        {
        path: 'enrollments/:status',
        component: GraphyLearnerListComponent,
        data: { title: 'Graphy Enrollments' }
      },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GraphyAdminRoutingModule { }
